module.exports = __webpack_public_path__ + "static/media/Logo_Empfehlung.5d721abc.png";